import { render, staticRenderFns } from "./batchView.vue?vue&type=template&id=66aecb43&scoped=true&"
import script from "./batchView.vue?vue&type=script&lang=js&"
export * from "./batchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aecb43",
  null
  
)

export default component.exports